<!--
 * Copyright    :Copyright© 2022 AOMEI
 * Abstract     :
 * Date         :2023-04-05 20:09:14
 * Author       :
 * LastEditors  :chenjia
 * LastEditTime :2024-05-23 14:41:37
 * FilePath     :\AV-COM-user-backend\src\App.vue
 * RevisionHistory:
-->
<template>
    <div id="app" :class="`av-${lang}`">
        <loading v-if="pageLoading" />
        <router-view v-if="isRouterAlive && !pageLoading" />
    </div>
</template>
<script>
import Loading from "@/components/Loading.vue";
import { debounce, currentLang } from "@/utils/util";
import { mapMutations, mapState } from "vuex";
export default {
    provide() {
        return {
            reload: this.reload,
        };
    },
    components: {
        Loading,
    },
    data() {
        return {
            lang: "en",
            isRouterAlive: true,
            pageLoading: process.env.NODE_ENV === "development" ? false : true, // 开启页面未加载
        };
    },
    watch: {
        perInfo: {
            handler(to) {
                // to.id && ();
                if (to.id) {
                    // alert(111);
                    this.pageLoading = false;
                }
            },
            immediate: true,
            deep: true,
        },
    },
    computed: {
        ...mapState({
            perInfo: (state) => state.userinfo.PERINFO,
        }),
    },
    methods: {
        ...mapMutations({
            setCHeight: "app/SET_HEIGHT",
            setCWidth: "app/SET_WIDTH",
        }),
        resize() {
            const width = document.documentElement.clientWidth; // 窗口宽度
            const height = document.documentElement.clientHeight; // 窗口高度
            this.setCHeight(height);
            this.setCWidth(width);
        },
        reload() {
            this.isRouterAlive = false;
            this.$nextTick(function () {
                this.isRouterAlive = true;
            });
        },

        addGtmScript() {
            const script = document.createElement("script");
            script.innerHTML = `(function (w, d, s, l, i) {
        w[l] = w[l] || []; w[l].push({
          'gtm.start': new Date().getTime(), event: 'gtm.js'
        }); var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src =
          'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f);
      })(window, document, 'script', 'dataLayer', 'GTM-PMPNGST');`;
            document.head.insertBefore(script, document.head.firstChild);
        },
        addGtmNoscript() {
            const noscript = document.createElement("noscript");
            noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-PMPNGST" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
            document.body.insertAdjacentElement("afterbegin", noscript);
        },
    },
    created() {},
    mounted() {
        // this.resize();
        const debouncedResize = debounce(this.resize, 500);
        window.onresize = debouncedResize;

        this.lang = currentLang();

        // 改变title
        if (this.$store.state.app.VERSION === "GN") {
            document.title = "远程看看";
        } else {
            this.addGtmScript();
            this.addGtmNoscript();
            document.title = "anyviewer";
        }
    },
};
</script>

<style lang="less"></style>
